import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SampleProducts } from "../data/sampleProducts";
import "./ProductInfo.css";

export default function ProductInfo() {
  const { id } = useParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const product = SampleProducts.find((p) => p.id === Number(id));

  if (!product) {
    return (
      <div className="not-found-product-info">
        <h2>Producto no encontrado</h2>
      </div>
    );
  }

  return (
    <div className={`card-product-info ${isMobile ? "mobile-product-info" : ""}`}>
      <div className="left-product-info">
        <img
          src={product.imageDetail || product.image}
          alt={product.imageAlt || product.name}
          loading="lazy"
          className="product-image-product-info"
        />
      </div>

      <div className="right-product-info">
        <div className="product-info-product-info">
          <div className="header-product-info">
            <h1 className="title-product-info">{product.name}</h1>
          </div>

          <div className="details-product-info">
            {product.subtitle && <h2 className="subtitle-product-info">{product.subtitle}</h2>}
            {product.description && (
              <h3 className="description-product-info">
                {product.description.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line.trim()}
                    <br />
                  </React.Fragment>
                ))}
              </h3>
            )}
          </div>

          <div className="buttons-product-info">
            <span className="button-product-info">
              <i className="fa fa-shopping-cart"></i> Contactar Ejecutivo
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
